export default "__VITE_ASSET__613e7dd8__"